import { Box, TableCell } from '@mui/material';
import { GridCellProps } from '@progress/kendo-react-grid';
import moment from 'moment';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useSalaryCellStyles } from './salaryCellStyles';

export const SalaryCell = ({ dataItem, rowType }: GridCellProps) => {
  const sxStyles = useSalaryCellStyles();
  const { salary } = dataItem;
  const { t } = useTranslation();

  if (!salary || rowType !== 'data') {
    return null;
  }

  return (
    <TableCell sx={sxStyles.dataCell}>
      <Box sx={sxStyles.text}>
        {`${salary.amount} ${salary.currency}/${salary.frequency}`}
        <p>
          {t('sinceDate', {
            date: moment(salary.startDate).format('L'),
          })}
        </p>
      </Box>
    </TableCell>
  );
};
